import React from "react";
import styled, { withTheme } from "styled-components";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import LabelledInput from "../../ui-library/LabelledInput/LabelledInput";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { noDateDefinedOrEmpty } from "../../../modules/constants";

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 48px;
  @media (max-width: 576px) {
    margin-top: auto;
    padding-top: 2rem;
    .btn {
      width: 100%;
    }
  }
`;

const PersonalData = (props) => {
  const { username, yearBirth, onClose } = props;

  const { t } = useTranslation();

  return (
    <FormContainer data-testid="personal-data">
      <LabelledInput
        title={t("appText.participantID")}
        value={username || ""}
        type="text"
        data-testid="ugnx-id"
        readOnly={true}
      />
      <LabelledInput
        className="mt-3"
        title={t("appText.yearOfBirth")}
        value={
          yearBirth && yearBirth !== noDateDefinedOrEmpty
            ? moment(yearBirth).format("Y")
            : "-"
        }
        type="text"
        data-testid="year-birth-id"
        readOnly={true}
      />

      <ActionButtonsContainer>
        <PrimaryButton data-testid="submit-button" onClick={onClose}>
          Close
        </PrimaryButton>
      </ActionButtonsContainer>
    </FormContainer>
  );
};

export default withTheme(PersonalData);
